import { styled } from "@phntms/css-components";
//import Image from "next/image";
import { Button, ButtonLink } from "../buttons/Button";
import styles from "./styles.module.scss";

export const CardContainer = styled("div", {
  css: [styles.cardContainer, "card"],
  variants: {
    decorated: {
      true: styles.decorated,
    },
  },
});
export const CardContent = styled("div", {
  css: [styles.cardContent],
  variants: {
    hoverable: {
      true: styles.hoverable,
    },
    hoverAnim: {
      true: styles.hoverAnim,
    },
    hideInMobile: {
      true: styles.hideInMobile,
    },
    deal: {
      true: [styles.deal, 'deal-highlight'],
    },
  },
});
export const CardContentSkeleton = styled("div", {
  css: [styles.cardContent, "skeleton"],
});

export const TextCardContent = styled("div", {
  css: [styles.cardContent, "text-card"],
  variants: {},
});

export const StyledFigure = styled("figure", {
  css: ['card-figure'],
  variants: {
    gradient: {
      true: [styles.gradient, 'gradient'],
    },
    textPosition: {
      top: styles.textPositionTop,
      bottom: styles.textPositionBottom,
    },
  },
});

export const TextContainer = styled("div", {
  css: [styles.textContainer],
  variants: {
    gradient: {
      true: styles.gradient,
    },
    color: {
      black: styles.blackCard,
      white: styles.whiteCard,
      gold: styles.goldCard,
    },
    active: {
      true: styles.activeCard,
    },
  },
});

export const CardRatio = styled("div", {
  css: [styles.cardRatio],
  variants: {
    ratio: {
      "16/9": styles.ratio_16_9,
      square: styles.ratioSquare,
      "9/16": styles.ratio_9_16,
      "3/4": styles.ratio_3_4,
      number: styles.ratioNumber,
      natural: [styles.natural],
    },
  },
});

export const CardDecoration = styled("div", {
  css: styles.cardDecoration,
  variants: {
    position: {
      left: styles.left,
      right: styles.right,
    },
  },
  defaultVariants: {
    position: "left",
  },
});

export const HoverOverlay = styled("div", {
  css: [styles.hoverOverlay, "card-hover-overlay"],
  variants: {},
});

export const Overlay = styled("figcaption", {
  css: [styles.overlay, "card-overlay"],
  variants: {
    textPosition: {
      top: styles.textPositionTop,
      bottom: styles.textPositionBottom,
    },
    textAlign: {
      left: styles.textAlignLeft,
      center: styles.textAlignCenter,
      right: styles.textAlignRight,
    },
  },
});

export const Caption = styled("p", {
  css: [styles.caption, "caption-txt"],
  variants: {},
});

export const Text = styled("p", {
  css: [styles.text, "medium-txt"],
  variants: {},
});

export const DealLabel = styled("div", {
  css: [styles.dealLabel, "medium-txt"],
  variants: {},
});

export const Title = styled("h4", {
  css: [styles.title, "title-small"],
  variants: {},
});

export const CtaButtonLink = styled(ButtonLink, {
  css: [styles.cta, 'card-cta-btn'],
  variants: {},
});
export const CtaButton = styled(Button, {
  css: [styles.cta, 'card-cta-btn'],
  variants: {},
});
